import axiosClient from "./axiosClient";

const authApi = {
    connectWithGoogle: async () => {
        const res = await axiosClient.get("/auth/google/connect");
        return res;
    },
    resetPasswordRequest: async (email: string) => {
        const res = await axiosClient.post("/auth/reset-password-request", { email });
        return res;
    },

    resetPasswordConfirm: async (token: string, newPassword: string) => {
        const res = await axiosClient.post("/auth/reset-password-confirm", { token, newPassword });
        return res;
    },
};

export default authApi;
